import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const RoomTemperatureModal = ({ isOpen, toggle, onTemperatureAdded }) => {
  const [temperature, setTemperature] = useState('');
  const [unit, setUnit] = useState('F');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!temperature) {
      setError('Please enter a temperature');
      return;
    }

    const temp = parseFloat(temperature);
    const min = unit === 'F' ? 30 : 0;
    const max = unit === 'F' ? 115 : 46;

    if (isNaN(temp) || temp < min || temp > max) {
      setError(`Temperature must be between ${min} and ${max} ${unit}`);
      return;
    }

    try {
      const response = await axios.post(`${BASE_URL}web/setRoomTemperature`, {
        temperature: temp,
        unit: unit
      });

      if (response.data.success) {
        onTemperatureAdded();
        toggle();
      } else {
        setError('Failed to set room temperature');
      }
    } catch (error) {
      console.error('Error setting room temperature:', error);
      setError('An error occurred while setting room temperature');
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Enter Room Temperature</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label for="temperature">Temperature</Label>
            <Input
              type="number"
              name="temperature"
              id="temperature"
              value={temperature}
              onChange={(e) => setTemperature(e.target.value)}
              invalid={!!error}
              step="0.1"
            />
            <FormFeedback>{error}</FormFeedback>
          </FormGroup>
          <FormGroup>
            <Label for="unit">Unit</Label>
            <Input
              type="select"
              name="unit"
              id="unit"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
            >
              <option value="F">°F</option>
              <option value="C">°C</option>
            </Input>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cancel</Button>
          <Button color="primary" type="submit">Submit</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default RoomTemperatureModal;
